import { Swiper } from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export const carousels = () => {
  const heroSwiper = document.querySelector(".hero-swiper");
  const carouselsSwipers = document.querySelectorAll("[data-carousel-swiper]");
  const coopSliders = document.querySelectorAll(".coop__slider");
  const valueSwiper = document.querySelector(".value__slider");
  const menuSwiper = document.querySelector(".menu__swiper");

  const setupValueBoxes = () => {
    const valueSection = document.querySelector(".strategy-page .value");

    if (!valueSection) {
      return null;
    }

    const valueSlides = Array.from(valueSection.querySelectorAll(".swiper-slide.slide"));
    const valueBoxes = Array.from(valueSection.querySelectorAll(".box"));

    if (!valueSlides.length || !valueBoxes.length) {
      return null;
    }

    valueSlides.forEach((slide, index) => {
      slide.dataset.element = String(index);
    });

    valueBoxes.forEach((box, index) => {
      box.dataset.element = String(index);
      box.hidden = true;
      box.setAttribute("aria-hidden", "true");
    });

    const setActiveBox = (elementIndex) => {
      valueBoxes.forEach((box) => {
        const isActive = box.dataset.element === String(elementIndex);
        box.hidden = !isActive;
        box.classList.toggle("is-active", isActive);
        box.setAttribute("aria-hidden", String(!isActive));
      });
    };

    const clearActiveBox = () => {
      valueBoxes.forEach((box) => {
        box.hidden = true;
        box.classList.remove("is-active");
        box.setAttribute("aria-hidden", "true");
      });
    };

    valueSection.addEventListener("click", (event) => {
      const slideButton = event.target.closest(".slide__btn");
      if (slideButton) {
        const slide = slideButton.closest(".swiper-slide.slide");
        const elementIndex = slide?.dataset.element;

        if (elementIndex === undefined) {
          return;
        }

        event.preventDefault();
        setActiveBox(elementIndex);
        return;
      }

      const boxButton = event.target.closest(".box__btn");
      if (boxButton) {
        event.preventDefault();
        clearActiveBox();
      }
    });

    return { setActiveBox, clearActiveBox };
  };
  
  const ensureMinimumSlides = (swiperEl, minimumCount) => {
    const wrapper = swiperEl?.querySelector(".swiper-wrapper");
    if (!wrapper) {
      return;
    }

    const originalSlides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
    if (originalSlides.length === 0 || originalSlides.length >= minimumCount) {
      return;
    }

    let slideIndex = 0;
    while (wrapper.querySelectorAll(".swiper-slide").length < minimumCount) {
      const sourceSlide = originalSlides[slideIndex % originalSlides.length];
      const cloneSlide = sourceSlide.cloneNode(true);
      cloneSlide.setAttribute("aria-hidden", "true");
      cloneSlide.classList.add("swiper-slide--clone");
      wrapper.appendChild(cloneSlide);
      slideIndex += 1;
    }
  };
  
  if (heroSwiper) {
    new Swiper(heroSwiper, {
      modules: [Autoplay, Pagination],
      loop: true,
      slidesPerView: 1,

      pagination: {
        el: ".hero .swiper-pagination",
        clickable: true,
      },
    });
  }
  coopSliders.forEach((coopSwiper) => {
    new Swiper(coopSwiper, {
      speed: 200,
      allowTouchMove: true,
  
      freeModeMomentum: false,
      slidesPerView: 1.3,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
     
    });
  });

  if (valueSwiper) {
    const valueBoxState = setupValueBoxes();
 
        ensureMinimumSlides(valueSwiper, 16);
    
    new Swiper(valueSwiper, {
      modules: [Autoplay, Navigation],
      speed: 500,
      grabCursor: true,
      watchOverflow: true,
      watchSlidesProgress: true,
      centeredSlides: true,
      loopAdditionalSlides: 6,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      slidesPerView: 1.6,
      spaceBetween: 20,
      loop:true,
      navigation: {
        prevEl: ".value__nav-left",
        nextEl: ".value__nav-right",
      },
      breakpoints: {
       
        992: {
          slidesPerView: 2.9,
          spaceBetween: 24,
          centeredSlides: false,
        },
        1280: {
          slidesPerView: 3.5,
          spaceBetween: 24,
          centeredSlides: false,
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 24,
          centeredSlides: false,
        },
      },
    });

    valueBoxState?.clearActiveBox();
  }

  carouselsSwipers.forEach((coopSwiper) => {
    new Swiper(coopSwiper, {
      modules: [Autoplay],
      loop: true,
      speed: 3000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      freeMode: {
        enabled: true,
        momentum: false,
      },
      freeModeMomentum: false,
      slidesPerView: 2.5,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        576: {
          slidesPerView: 3.5,
          spaceBetween: 24,
        },
      },
    });
  });

  if (menuSwiper) {
    const updateMenuEdgeState = (swiper) => {
      menuSwiper.classList.toggle("menu__swiper--at-start", swiper.isBeginning);
      menuSwiper.classList.toggle("menu__swiper--at-end", swiper.isEnd);
    };

    new Swiper(menuSwiper, {
      modules: [Autoplay],
      spaceBetween: 0,
      speed: 900,
      grabCursor: true,
      resistanceRatio: 0,
      watchOverflow: true,
      on: {
        init(swiper) {
          updateMenuEdgeState(swiper);
        },
        slideChange(swiper) {
          updateMenuEdgeState(swiper);
        },
        reachBeginning(swiper) {
          updateMenuEdgeState(swiper);
        },
        reachEnd(swiper) {
          updateMenuEdgeState(swiper);
        },
        fromEdge(swiper) {
          updateMenuEdgeState(swiper);
        },
      },
      breakpoints: {
        0: {
          slidesPerView: "auto",
          centeredSlides: false,
        },
        576: {
          slidesPerView: 3,
          centeredSlides: false,
        },
        992: {
          slidesPerView: 4.5,
          centeredSlides: false,
        },
        1440: {
          slidesPerView: 5.5,
          centeredSlides: false,
        },
      },
    });
  }
};
